'use strict';

module.exports = require('../src/traces/treemap');
